const removeHashFromColor = (color: string) => color.slice(1);

export default removeHashFromColor;
